import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CookieConsent } from './CookieConsent';
import { YandexMetrika } from './YandexMetrika';
import { Toaster } from 'react-hot-toast';
import { useSession } from '../hooks/useSession';

export function Layout() {
  // Initialize session management
  useSession();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <YandexMetrika />
      <Toaster position="top-right" />
    </div>
  );
}